import React, { useState, useEffect } from 'react';
import SquareSvg from '../../../assets/svg/square.svg';
import GoogleTagManagerSvg from '../../../assets/svg/googleTagManager.svg';
import GoogleCalendarSvg from '../../../assets/svg/googleCalendar.svg';
import MicrosoftSvg from '../../../assets/svg/microsoft.svg';
import GoogleReviewSvg from '../../../assets/svg/googleReview.svg';
import TrustpilotSvg from '../../../assets/svg/trustpilot.svg';
import PaymentIntegrationCard from '../../../components/Common/PaymentCard';
import GoogleCalendarOAuthCard from '../../../components/Common/googleCalendarOAuthCard';
import GoogletagmangerCard from '../../../components/Common/googleTagmanagerCard';
import DentallyCard from '../../../components/Common/dentallyCard';
import GoogleReviewCard from '../../../components/Common/googleReviewCard';
import TrustpilotCard from '../../../components/Common/trustpilotCard';
import { useAuthStore } from '../../../zustand-store/auth.store';
import {
  getSquarePayLocations,
  bindSquareLocation,
  isSquareConnected,
  connectStripe
} from '../../../axios/oauth/oauth';

import {
  Modal,
  ModalHeader,
  ModalBody,
  Button,
  ModalFooter,
  Container,
  Row,
  Col
} from 'reactstrap';
// import Breadcrumbs from '../../../components/Common/Breadcrumb';
import { toast } from 'react-toastify';
import VerticalLayout from '../../../components/VerticalLayout';
import { checkLocationEligibility } from '../../../axios/locations/index.api';
import { ROLES } from '../../../constants/layout';
import MicroSoftCalendarOAuthCard from '../../../components/Common/microsoftOAuthCard';
import StripeIntegrationCard from '../../../components/Common/StripeIntegrationCard';
import StripeSvg from '../../../assets/svg/stripe.svg';
import DentallySvg from '../../../assets/svg/dentally.svg';
const PaymentIntegrations = () => {
  document.title = 'Integration Settings | Seamless Slot';
  const accessToken = useAuthStore((state) => state.accessToken);
  const locationId = useAuthStore((state) => state.locationId);
  const [locationPopup, setLocationPopup] = useState(false);
  const [squareLocations, setSquareLocations] = useState([]);
  const [selectedLocationId, setSelectedLocationId] = useState('');
  const [integartionFlag, setIntegrationFlag] = useState(false);
  const [isSquareIntegrated, setIsSquareIntegarted] = useState(null);
  const [stripeRequirementsDue, setStripeRequirementsDue] = useState(null);
  const { role } = useAuthStore((state) => state);
  const [disabledReason, setDisabledReason] = useState(null);
  const handleAuth = () => {
    // const width = 600;
    // const height = 600;
    // const left = window.innerWidth / 2 - width / 2;
    // const top = window.innerHeight / 2 - height / 2;

    const authWindow = window.open(
      import.meta.env.VITE_SQUARE_OAUTH_START + `?jid=${accessToken}&locationId=${locationId}`,
      'Square OAuth'
      // `width=${width},height=${height},top=${top},left=${left}`
    );
    // const checkAuthWindowClosed = setTimeout(() => {
    //   if (authWindow.closed) {
    //     clearInterval(checkAuthWindowClosed);
    //     // window.removeEventListener('message', messageListener);
    //     getSquareLocations(locationId);
    //   }
    // }, 1000);
    if (!authWindow) {
      alert('Popup blocked. Please allow popups for this site.');
      return;
    }
  };

  const checkAvaliablity = async () => {
    const response = await checkLocationEligibility(locationId);
    if (response.data.data.paymentAccount) {
      useAuthStore.getState().appTourToggle();
    }
  };
  const getSquareLocations = async () => {
    let data = await getSquarePayLocations(locationId);
    if (data.length > 0) {
      setSquareLocations(data);
      setLocationPopup(true);
    }
  };
  const saveLocation = async () => {
    let data = await bindSquareLocation(selectedLocationId, locationId);
    if (data?.status === 200) {
      toast.success('Square connected successfully');
      setLocationPopup(false);
      setIntegrationFlag(!integartionFlag);
      if (role === ROLES.BUSINESS_ADMIN) {
        checkAvaliablity();
      }
    }
  };
  useEffect(() => {
    const handleVisibilityChange = async () => {
      if (document.visibilityState === 'visible') {
        let response = await isSquareConnected(locationId);
        const invalidValues = ['', 'empty'];
        if (invalidValues.includes(response?.data?.data?.squareLocationId)) {
          getSquareLocations();
        }
      } else {
        console.log('something went wrong while adding getting square ststaus');
      }
    };

    // Attach the event listener
    document.addEventListener('visibilitychange', handleVisibilityChange);

    // Cleanup function to remove the listener
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [locationId]);
  const connectStripeClient = async (setLoading, countryCode) => {
    try {
      setLoading(true);
      const response = await connectStripe(locationId, countryCode);

      if (response.status === 200 || response.status === 201) {
        const redirectUrl = response?.data?.data?.url;

        if (redirectUrl) {
          window.location.assign(redirectUrl);
          //  window.open(redirectUrl, "noopener,noreferrer");
        }
      }
    } catch (error) {
      console.error('Stripe connect error:', error);
    }
  };

  const handleStripeClick = (setLoader) => {
    setLoader(true);
    if (stripeRequirementsDue && stripeRequirementsDue.length > 0) {
      connectStripeClient(setLoader, '');
    } else {
      connectStripeClient(setLoader, 'United Kingdom');
    }
  };
  return (
    <VerticalLayout>
      <React.Fragment>
        <Container fluid>
          <div className="page-content ">
            {/* <Breadcrumbs title="Integrations" breadcrumbItem="settings" /> */}
            <div className="d-flex justify-content-between align-items-center w-100 mb-3">
              {/* Left side */}
              <p style={{ fontSize: '16px', fontWeight: 500, color: '#000', margin: 0 }}>
                Integration Settings
              </p>

              {/* Right side */}
              <div className="d-flex align-items-center gap-3"></div>
            </div>
            <Modal isOpen={locationPopup}>
              <ModalHeader>Sqaure pay Locations</ModalHeader>
              <ModalBody>
                <select
                  onChange={(e) => {
                    setSelectedLocationId(e.target.value);
                  }}
                  className="form-select"
                  aria-label="Default select example">
                  <option value="" selected>
                    Select square pay location
                  </option>
                  {squareLocations?.map((item, index) => (
                    <option key={index} value={item?.locationId}>
                      {' '}
                      {item?.name}
                    </option>
                  ))}
                </select>
              </ModalBody>
              <ModalFooter>
                <Button
                  type="button"
                  onClick={() => {
                    if (selectedLocationId == '') {
                      toast.error('Location not selected');
                    } else {
                      saveLocation();
                    }
                    // toggle(false);
                  }}
                  color="success">
                  Save
                </Button>
              </ModalFooter>
            </Modal>
            {/* <div className="d-flex align-items-center">
              <p style={{ color: '#495057', fontWeight: '600', fontSize: '15px' }} className="p-2">
                Integrations
              </p>
            </div> */}
            <div className="row ">
              <div className="d-flex align-items-center ">
                <p
                  style={{ color: '#495057', fontWeight: '600', fontSize: '15px', marginLeft: 10 }}>
                  Payment
                </p>
              </div>
              <div className="col-12 col-md-4">
                <PaymentIntegrationCard
                  description={
                    'Get paid for your services via Square, Cash App, Apple Pay or Google Pay.'
                  }
                  title={'Square'}
                  icon={SquareSvg}
                  integartionFlag={integartionFlag}
                  onClick={handleAuth}
                  isSquareIntegrated={isSquareIntegrated}
                  setIsSquareIntegarted={setIsSquareIntegarted}
                />
              </div>
              <div className="col-12 col-md-4">
                <StripeIntegrationCard
                  description={
                    'Get paid for your services via Stripe, Cash App, Apple Pay or Google Pay.'
                  }
                  title={'Stripe'}
                  icon={StripeSvg}
                  integartionFlag={integartionFlag}
                  onClick={handleStripeClick}
                  isSquareIntegrated={isSquareIntegrated}
                  setIsSquareIntegarted={setIsSquareIntegarted}
                  setIntegrationFlag={setIntegrationFlag}
                  onRequirementsDueChange={setStripeRequirementsDue}
                  setDisabledReason={setDisabledReason}
                  disabledReason={disabledReason}
                />
              </div>
            </div>
            <div className="row ">
              <div className="d-flex align-items-center  ">
                <p
                  style={{ color: '#495057', fontWeight: '600', fontSize: '15px', marginLeft: 10 }}>
                  Analatics
                </p>
              </div>

              <div className="col-12 col-md-4">
                <GoogletagmangerCard
                  description={'Monitor how visitors engage with your custom Booking Page.'}
                  title={'Google Tag Manager'}
                  icon={GoogleTagManagerSvg}
                  integartionFlag={integartionFlag}
                  //  onClick={handleAuth}
                />
              </div>
            </div>
            <div className="row ">
              <div className="d-flex align-items-center  ">
                <p
                  style={{ color: '#495057', fontWeight: '600', fontSize: '15px', marginLeft: 10 }}>
                  Dentally
                </p>
              </div>

              <div className="col-12 col-md-4">
                <DentallyCard
                  description={'The practice management solution for stress-free dentistry'}
                  title={'Dentally'}
                  icon={DentallySvg}
                  integartionFlag={integartionFlag}
                  //  onClick={handleAuth}
                />
              </div>
            </div>
            <div className="row ">
              <div className="d-flex align-items-center  ">
                <p
                  style={{ color: '#495057', fontWeight: '600', fontSize: '15px', marginLeft: 10 }}>
                  Reviews
                </p>
              </div>

              <div className="col-12 col-md-4">
                <GoogleReviewCard
                  description={'Show your Google reviews and average rating on your booking page.'}
                  title={'Google Reviews'}
                  icon={GoogleReviewSvg}
                />
              </div>
              <div className="col-12 col-md-4">
                <TrustpilotCard
                  description={'Collect and showcase reviews from your customers on Trustpilot.'}
                  title={'Trustpilot'}
                  icon={TrustpilotSvg}
                />
              </div>
            </div>
            <div className="row">
              <div className="d-flex align-items-center ">
                <p
                  style={{ color: '#495057', fontWeight: '600', fontSize: '15px', marginLeft: 10 }}>
                  Calendar
                </p>
              </div>
              <Row>
                <Col sm={4}>
                  <GoogleCalendarOAuthCard
                    description={
                      'Easily manage and sync your appointments with Google Calendar to stay organized and never miss a booking.'
                    }
                    title={'Google Calendar'}
                    icon={GoogleCalendarSvg}
                  />
                </Col>
                <Col sm={4}>
                  <MicroSoftCalendarOAuthCard
                    description={
                      'Easily manage and sync your appointments with Microsoft Calendar to stay organized and never miss a booking.'
                    }
                    title={'Microsoft Calendar'}
                    icon={MicrosoftSvg}
                  />
                </Col>
              </Row>
            </div>
          </div>
        </Container>
      </React.Fragment>
    </VerticalLayout>
  );
};

export default PaymentIntegrations;
